// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"39":"mobile-overlay","366":"mobile/share-popup-content","397":"widget/vod-player"}[chunkId] || chunkId) + ".chunk.min.css";
};